import { Link } from "react-router-dom";
import styles from "./style/Introduction.module.css";
import Menu from "./menu.png";
import Music from "./image15.png";
import Introduction1 from "./introduction1.png";
import type1 from "./type1.jpg";
import type2 from "./type2.jpg";
import type3 from "./type3.jpg";
import type4 from "./type4.jpg";
import type5 from "./type5.jpg";

function ChangeContent1() {
  let menu = document.getElementById("Menu");
  menu.style.height = "100vh";
}

function ChangeContent2() {
  let menu = document.getElementById("Menu");
  menu.style.height = "0";
}

function Introduction() {
  return (
    <div className={styles.main}>
      <div className={styles.menu} id="Menu">
        <div className={styles.menutitle}>
          <Link to="/" className={styles.menutitletext}>
            <div>Rhythm with Game</div>
          </Link>
          <img
            src={Menu}
            className={styles.menuimg}
            id="icon"
            onClick={ChangeContent2}
          />
        </div>
        <div className={styles.menutext}>A playable website for music</div>
        <div className={styles.speciallink} onClick={ChangeContent2}>
          Introduction
        </div>
        <Link to="/games" className={styles.link}>
          <div>Games</div>
        </Link>
        <Link to="/story" className={styles.link}>
          <div>Creator’s Story</div>
        </Link>
        <Link to="/music" className={styles.link}>
          <div>
            <img className={styles.listen} src={Music} /> Enjoy the Music
          </div>
        </Link>
      </div>
      <div className={styles.original} id="Original">
        <div className={styles.title}>
          <div className={styles.titletext}>Introduction</div>
          <img src={Menu} className={styles.img} onClick={ChangeContent1} />
        </div>
        <div className={styles.textblock}>
          <div className={styles.subtitle}>Definition and game design</div>
          <div className={styles.text}>
            <div className={styles.defblock}>
              <div>
                <strong>Rhythm game</strong> or <strong>rhythm action</strong>{" "}
                is a genre of{" "}
                <a href="https://en.wikipedia.org/wiki/Music_video_game">
                  music-themed
                </a>{" "}
                action video game that challenges a player's sense of rhythm.
                The genre includes dance games such as{" "}
                <i>Dance Dance Revolution</i> and music-based games such as{" "}
                <i>Donkey Konga</i> and <i>Guitar Hero</i>. Games in the genre
                challenge the player to press buttons at precise times: the
                screen shows which button the player is required to press, and
                the game awards points both for accuracy and for synchronization
                with the beat. The genre also includes games that measure rhythm
                and pitch, in order to test a player's singing ability, and
                games that challenge the player to control their volume by
                measuring how hard they press each button. While songs can be
                sight read, players usually practice to master more difficult
                songs and settings. Certain rhythm games offer a challenge
                similar to that of Simon says, in that the player must watch,
                remember, and repeat complex sequences of button-presses.
                Rhythm-action can take a minigame format with some games
                blending rhythm with other genres or entirely comprising
                minigame collections.
              </div>
              <img src={Introduction1} class={styles.textimg} />
            </div>
            In some rhythm games, the screen displays an avatar who performs in
            reaction to the player's controller inputs. However, these graphical
            responses are usually in the background, and the avatar is more
            important to spectators than it is to the player. In single-player
            modes, the player's avatar competes against a computer-controlled
            opponent, while multiplayer modes allow two player-controlled
            avatars to compete head-to-head. The popularity of rhythm games has
            created a market for speciality input devices. These include
            controllers that emulate musical instruments, such as guitars,
            drums, or maracas. A dance mat, for use in dancing games, requires
            the player to step on pressure-sensitive pads. However, most rhythm
            games also support more conventional input devices, such as control
            pads.
          </div>
        </div>
        <div className={styles.textblock}>
          <div className={styles.subtitle}>History Evolution</div>
          <div className={styles.text}>
            The roots of rhythm games can be traced back to the arcade era of
            the 1970s and 1980s, with titles like "Dance Aerobics" and "PaRappa
            the Rapper" laying the groundwork for what was to come. However, it
            was the release of "Dance Dance Revolution" in the late 1990s that
            popularized the genre and paved the way for its expansion into
            various subgenres and platforms.
            <br />
            As technology advanced, rhythm games became more sophisticated,
            incorporating motion sensors, touch screens, and virtual reality to
            enhance the player experience. Today, rhythm games encompass a wide
            range of styles and formats, from traditional arcade machines to
            mobile apps and virtual reality experiences.
          </div>
        </div>
        <div className={styles.textblock}>
          <div className={styles.subtitle}>Types of Rhythm Games</div>
          <div className={styles.typeblock}>
            <div>
              <div className={styles.typetext}>
                <strong>1. Arcade Rhythm Games:</strong>
                <br />
                These are typically played on specialized arcade machines and
                often involve physical interaction, such as pressing buttons,
                tapping panels, or even dancing on a dance pad. Examples include
                "Dance Dance Revolution", "Maimai DX", and "Guitar Hero".
                <img src={type1} className={styles.textimg} />
              </div>
            </div>
            <div>
              <div className={styles.typetext}>
                <strong>2. Mobile Rhythm Games:</strong> <br />
                With the widespread adoption of smartphones, rhythm games have
                found a new home on mobile platforms. These games are designed
                to be played on touchscreen devices and often feature simplified
                gameplay mechanics and a wide variety of music genres. Popular
                examples include "Arcaea", "Cytus", and "Deemo".
                <img src={type2} className={styles.textimg} />
              </div>
            </div>
            <div>
              <div className={styles.typetext}>
                <strong>3. Console Rhythm Games:</strong>
                <br /> Many rhythm games are developed for home gaming consoles,
                offering immersive experiences with high-quality graphics and
                sound. These games often come with dedicated peripherals, such
                as instrument controllers or dance pads. Notable titles include
                "Rock Band", "DJ Hero", and "Taiko no Tatsujin".
                <img src={type3} className={styles.textimg} />
              </div>
            </div>
            <div>
              <div className={styles.typetext}>
                <strong>4. PC Rhythm Games:</strong> <br />
                PC gamers also have access to a variety of rhythm games, ranging
                from indie titles to mainstream releases. These games can be
                played using a keyboard, mouse, or specialized controllers.
                Examples include "osu!", "Crypt of the Necrodancer", and "Muse
                Dash".
                <img src={type4} className={styles.textimg} />
              </div>
            </div>
            <div>
              <div className={styles.typetext}>
                <strong>5. Virtual Reality Rhythm Games:</strong> <br />
                With the rise of virtual reality technology, developers have
                begun exploring rhythm games in immersive 3D environments. These
                games often require players to physically move and interact with
                objects in sync with the music. Examples include "Beat Saber",
                "Audica", and "Synth Riders".
                <img src={type5} className={styles.textimg} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Introduction;
